'use client';

import { useTranslations } from 'next-intl';
import { useSiteStore } from '@/store/site';
import { useStore } from '@/hooks';
import { SwitchFromEnum } from '@nf/types/site';
import { useGetSiteConfigsWithSession } from '@/hooks/query/use-site-configs';
import { useAppearanceStore } from '@/store/appearance';
import { ViewEnum } from '@/types';
import { Button } from '@nf/ui';
import { ArrowLeftIcon } from '@/components/icons/svg-icons';
import { Logo } from '@/components/core/logo';
import { useGetSiteConfigs } from '@/hooks/query/use-site-configs';

export const BackToMainSite = ({ style }: { style: any }) => {
	const { SiteConfigsWithSessionData } = useGetSiteConfigsWithSession();
	const t = useTranslations('General');
	const homeUrl = useStore(useSiteStore, state => state.deepLinkSiteInfo.homeUrl);
	const platFrom = SiteConfigsWithSessionData?.SwitchFrom;
	const view = useAppearanceStore(state => state.view);
	const { SiteConfigsData } = useGetSiteConfigs();

	// const handleClick = () => {
	// 	const isMobileMode = window.innerWidth < 750;
	// 	const kafkaData = {
	// 		note: KafkaNote.GalaxyV2,
	// 		type: isMobileMode ? 4 : 5,
	// 		action: 1
	// 	}
	// 	setKafkaNormal(kafkaData);
	// }

	const handleMarsClick = () => {
		if (homeUrl) {
			window.location.href = homeUrl;
		}
	}

	return homeUrl && platFrom !== SwitchFromEnum.Desktop ? (view === ViewEnum.galaxy || style === null ? (
		null
		// <Link
		// 	onClick={handleClick}
		// 	href={homeUrl}
		// >
		// 	<div className="side-back">
		// 		<ReturnIcon />
		// 		<div className="text">{t('lbl_BackToMainSite')}</div>
		// 	</div>
		// </Link>
	) : (
		<Button
			variant="icon"
			className={style?.backButton}
			onClick={handleMarsClick}
		>
			{SiteConfigsData?.GalaxyLogoType === 0 ?
				<>
					<ArrowLeftIcon />
					{t('lbl_homeURLText')}
				</>
				:
				<div className={style?.homeLogo}>
					<Logo />
				</div>
			}
		</Button>
	)) : null;
};